import axios from 'axios';
import _orderBy from 'lodash.orderby';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    getGaClientId,
    handleCloseDropdownOnBlur,
    handleCloseInputDropdownOnBlur,
    handleLoadSharpsringScriptUrl,
    handleSetSharpspringScript,
    handleSharpspringSubmit,
    normalizeModelName,
    setCaptchaEuScript,
} from '../utils';
import { isCaptchaEnabled } from '../services/captcha';
import { getFormRenderToken } from '../services/anti-bot';

Vue.component('request-testdrive-component', {
    props: {
        allStores: {
            value: Array,
        },
        imStores: {
            value: Array,
        },
        distributors: {
            value: Array,
        },
        siteHandle: {
            value: String,
        },
        testdriveModels: {
            value: Array,
        },
        defaultModel: {
            value: String,
        },
        resetCountries: {
            value: Boolean,
        },
        brandstoreResultAmount: {
            value: Number,
        },
        sharpspringBaseUrl: {
            value: String,
        },
        sharpspringEndpointId: {
            value: String,
        },
        sharpspringScriptUrl: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isExternalTestDriveForm: {
            value: Boolean,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            formRenderToken: '',
            stores: this.defaultModel.toLowerCase().includes('im')
                ? this.imStores
                : this.allStores,
            errors: new Errors(),
            successMessage: '',
            formCompleted: false,
            submitting: false,
            selectedBrandStore: null,
            requestType: 'private',
            requestIndex: 0,
            countryHandle: '',
            color: 'white',
            heardFrom: null,

            model: '',
            modelName: 'MG ZS EV',

            dropdownCountry: null,
            dropdownHeardFrom: null,

            internalCountryHandle: '',

            guyane: 'GF',
            martinique: 'GF',
            mayotte: 'YT',
            reunion: 'RE',
            guadeloupe: 'GP',

            isNumberValid: true,

            newsletterSignUp: false,

            dropdownPreferredTime: null,
            preferredTime: null,
            dropdownGender: null,
            gender: null,
        };
    },

    computed: {
        orderedStores: function () {
            return _orderBy(this.stores, 'title');
        },

        isCompanyInputVisible: function () {
            return (
                this.requestType === 'business' || this.siteHandle === 'default'
            );
        },

        isPostalCodeInputVisible: function () {
            const countriesExcluded = [
                'mgMotorsNetherlands',
                'mgMotorsIceland',
                'mgMotorsNorway',
                'mgMotorsSpain',
                'mgMotorsItaly',
                'mgMotorsPortugal',
                'mgMotorsSweden',
                'mgMotorsHungary',
                'mgMotorsGreece',
                'mgMotorsMacedonia',
                'mgMotorsBelgiumNl',
                'mgMotorsBelgiumFr',
                'mgMotorsLuxembourgFr',
            ];

            return !countriesExcluded.includes(this.siteHandle);
        },

        isCityInputVisible: function () {
            const countries = ['default', 'mgMotorsFrance'];
            return countries.includes(this.siteHandle);
        },

        isCountryEurope: function () {
            return this.siteHandle === 'default';
        },

        isStreetNameInputVisible: function () {
            const countries = ['default'];
            return countries.includes(this.siteHandle);
        },

        isSubmitLoading: function () {
            return this.submitting ? 'button--loading' : '';
        },

        isSwitchButtonVisible: function () {
            const notAvailableCountries = [
                // 'mgMotorsGermany',
                'mgMotorsAustria',
                'mgMotorsMalta',
            ];
            return !notAvailableCountries.includes(this.countryHandle);
        },
    },

    watch: {
        model(newValue, oldValue) {
            // IM Specific brandstores are added only for Switzerland countries
            const switzerlandCountries = [
                'mgMotorsSwitzerlandIt',
                'mgMotorsSwitzerlandDe',
                'mgMotorsSwitzerlandFr',
            ];

            if (!switzerlandCountries.includes(this.siteHandle)) {
                this.stores = this.allStores;
                return;
            }

            if (newValue.toLowerCase().includes('im')) {
                this.stores = this.imStores;
            } else {
                this.stores = this.allStores;
            }
        },

        carId() {
            if (this.carId) {
                this.fetchAvailableDates();
            }
        },

        selectedDate() {
            if (this.selectedDate) {
                this.selectDate();
            }
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.model = this.defaultModel;
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }

        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });

        handleCloseDropdownOnBlur('.new-input__dropdown-container--model');
        handleCloseDropdownOnBlur('#heard-from-dropdown');
        handleCloseDropdownOnBlur('#country-dropdown');
        handleCloseDropdownOnBlur('#brandstore-dropdown');
        handleCloseInputDropdownOnBlur(
            '#store-dropdown-container',
            '#searchBrandstore',
        );

        EventBus.$on('brandstore-selected', (brandstoreValue) => {
            this.selectedBrandStore = brandstoreValue;
        });

        if (this.isExternalTestDriveForm) {
            const html = document.getElementsByTagName('html')[0];
            html.style.background = 'white';
            html.style.minHeight = 'fit-content';
        }
    },

    created() {
        handleSetSharpspringScript(
            this.siteHandle,
            this.sharpspringBaseUrl,
            this.sharpspringEndpointId,
            'testDrive',
        );
        handleLoadSharpsringScriptUrl(
            this.siteHandle,
            this.sharpspringScriptUrl,
        );
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        handleToggleButtonActiveClass(index) {
            return this.requestIndex === index ? 'checked' : '';
        },

        handleMarketingConsentChange(e) {
            e.preventDefault();
            const isConsentChecked = e.target.checked;
            this.newsletterSignUp = isConsentChecked;
            const hiddenMarketingInput = document.querySelector('#marketing');
            if (!hiddenMarketingInput) return;
            hiddenMarketingInput.setAttribute(
                'value',
                isConsentChecked ? '1' : '0',
            );
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            this.successMessage = '';
            const form = event.currentTarget;
            let formData = new FormData(form);
            const data = {};

            for (let [key, val] of formData.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            const isCompany =
                data.hasOwnProperty('company') && Boolean(data.company.length);

            const dataLayerData = {
                event: 'lead',
                lead_type: 'Test Drive',
                client_type: isCompany ? 'B2B' : 'B2C',
                brandstore: this.selectedBrandStore
                    ? this.selectedBrandStore.title
                    : '',
                payment_type: '',
                car: {
                    name: normalizeModelName(this.model, this.siteHandle),
                    ids: [],
                    edition: '',
                    color: '',
                },
                user_data: {
                    email_address: data.emailAddress,
                    phone_number: data.phone,
                    address: {
                        first_name: data.firstName,
                        last_name: data.lastName,
                    },
                },
            };

            if (this.countryHandle === 'mgMotorsPoland') {
                const uniqueFormId = crypto.randomUUID();
                dataLayerData.unique_form_id = uniqueFormId;
            }

            if (!this.isNumberValid) {
                this.submitting = false;
                return;
            }

            const testDriveDisclaimerField = form.querySelector(
                '[name="testDriveDisclaimer"]',
            );
            const disclaimerUnchecked =
                testDriveDisclaimerField && !testDriveDisclaimerField.checked;

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form, dataLayerData, null, disclaimerUnchecked);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(
                    form,
                    dataLayerData,
                    captchaSolution,
                    disclaimerUnchecked,
                );
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, dataLayerData, captchaSolution, disclaimerUnchecked = false) {
            try {
                const formData = new FormData(form);
                formData.append('sourceUrl', window.location.href);
                formData.append('gaClientId', getGaClientId());
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                formData.append('formRenderToken', this.formRenderToken);
                const response = await axios.post('/', formData);

                const result = response.data;

                if (result.data?.errors || disclaimerUnchecked) {
                    const serverErrors = result.data?.errors ?? {};
                    const disclaimerError = disclaimerUnchecked
                        ? { testDriveDisclaimer: ['required'] }
                        : {};
                    this.errors.record({ ...serverErrors, ...disclaimerError });

                    this.scrollToFirstError();
                    this.submitting = false;
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();
                this.isNumberValid = true;

                this.sendGTMData(dataLayerData);
                handleSharpspringSubmit(
                    this.siteHandle,
                    this.sharpspringEndpointId,
                );

                if (this.isExternalTestDriveForm) {
                    this.successMessage = result.data['form-general-success'];
                    return;
                }

                setTimeout(() => {
                    window.location = result.data.redirectUrl;
                }, 1000);
            } catch (e) {
                throw new Error(e);
            }
        },

        sendGTMData(extraDataToPush) {
            const country =
                this.siteHandle == 'default'
                    ? 'mgMotorsEurope'
                    : this.siteHandle;

            if (checkCCM19Consent() || checkOneTrustConsent()) {
                // check if you are on production-enviroment
                if (!window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                }

                if (extraDataToPush) {
                    window.dataLayer.push(extraDataToPush);
                }

                window.dataLayer.push({
                    event: 'request test drive',
                    model: normalizeModelName(this.model, this.siteHandle),
                    edition: ' ',
                    page_path: window.location.href,
                    country: `${country} - ${this.$root.languageCode}`,
                });
            }
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        setDropdownCountry(event) {
            event.preventDefault();
            this.toggleDropdown(event);

            this.dropdownCountry = event.currentTarget.dataset.text;
            this.countryHandle = event.currentTarget.dataset.value;
            this.internalCountryHandle = event.currentTarget.dataset.dorm;
        },

        resetCountryDropdown() {
            if (!this.resetCountries) {
                return;
            }

            this.dropdownCountry = null;
            this.countryHandle = '';
        },

        setDropdownHeardFrom(event) {
            event.preventDefault();
            this.dropdownHeardFrom = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.heardFrom = value;
        },

        setDropdownPreferredTime(event) {
            this.dropdownPreferredTime = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.preferredTime = value;
        },

        setDropdownGenderPicker(event) {
            this.dropdownGender = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.gender = value;
        },
    },
});
